<template>
  <v-row>
    <v-col cols="12" lg="7">
      <v-form ref="edit" @submit.prevent="update">
        <v-card>
          <v-card-title>Pengaturan Profil</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="req.nip"
              placeholder="Masukkan NIP"
              label="NIP"
              :rules="[(v) => !!v || 'nip harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.nama"
              placeholder="Masukkan Nama"
              label="Nama"
              :rules="[(v) => !!v || 'nama harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.jenis_ptk"
              placeholder="Masukkan Jenis PTK"
              label="Jenis PTK"
              :rules="[(v) => !!v || 'jenis PTK harus diisi']"
            ></v-text-field>
            <v-text-field
              :value="req.level ? req.level.toUpperCase() : ''"
              disabled
              placeholder="Masukkan Level"
              label="Level"
              :rules="[(v) => !!v || 'level harus diisi']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
    <v-col cols="12" lg="5">
      <v-form ref="auth" @submit.prevent="updateAuthenticate">
        <v-card>
          <v-card-title>Pengaturan Autentikasi</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="req_auth.username"
              placeholder="Masukkan Nama"
              label="Username"
              :rules="[(v) => !!v || 'username harus diisi']"
            ></v-text-field>
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              v-model="req_auth.password"
              placeholder="Masukkan Password"
              label="Password"
              :rules="[
                (v) => !!v || 'password harus diisi',
                (v) =>
                  !(v ? v.length < 8 : true) || 'password minimal 8 karakter',
              ]"
              min="8"
              counter="20"
              maxlength="20"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      req: {},
      req_auth: {},
      id: this.$root.app.xid,
      showPassword: false,
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$root.app.http.get("/api/guru/" + this.id).then((res) => {
        this.req = res.data;
        this.req_auth.username = res.data.username;
      });
    },
    update() {
      if (this.$refs.edit.validate()) {
        this.$root.app.http
          .put("/api/guru/" + this.id, this.req)
          .then((res) => {
            if (res.error) {
              this.$root.app.notif(res.message[0], true);
            } else {
              this.$root.app.notif(res.message);
            }
          });
      }
    },
    updateAuthenticate() {
      if (this.$refs.auth.validate()) {
        this.$root.app.http
          .put("/api/guru/" + this.id + "/autentikasi", this.req_auth)
          .then((res) => {
            if (res.error) {
              this.$root.app.notif(
                typeof res.message == "string" ? res.message : res.message[0],
                true
              );
            } else {
              this.req_auth.password_lama = "";
              this.req_auth.password_baru = "";
              this.$refs.auth.resetValidation();
              this.$root.app.notif(res.message);
            }
          });
      }
    },
  },
};
</script>
